export const iconFontAwesomeHumanitarianTruck = (
	<i className="fa-solid fa-truck"></i>
);
